var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwiter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "twiter",
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.172,
    height: 33.605,
    viewBox: "0 0 34.172 33.605",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Main-Desktop"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Footer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "social-normal"
  }, /*#__PURE__*/React.createElement("g", {
    id: "twitter-icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Page-1",
    d: "M34.172,16.8a16.946,16.946,0,0,1-17.086,16.8A16.946,16.946,0,0,1,0,16.8,16.946,16.946,0,0,1,17.086,0,16.946,16.946,0,0,1,34.172,16.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_777",
    "data-name": "Path 777",
    d: "M20.757,11.385c0,.129.008.259.008.389A8.553,8.553,0,0,1,7.6,18.969a6.276,6.276,0,0,0,.718.042,6.037,6.037,0,0,0,3.734-1.285,3.009,3.009,0,0,1-2.809-2.086,2.972,2.972,0,0,0,.566.055,3.037,3.037,0,0,0,.792-.105,3.005,3.005,0,0,1-2.411-2.944v-.038a3,3,0,0,0,1.361.375,3.006,3.006,0,0,1-.93-4.009,8.541,8.541,0,0,0,6.2,3.138,3.07,3.07,0,0,1-.077-.685,3.008,3.008,0,0,1,5.2-2.054,6.027,6.027,0,0,0,1.909-.729A3.005,3.005,0,0,1,20.53,10.3a5.991,5.991,0,0,0,1.728-.472,6.116,6.116,0,0,1-1.5,1.554",
    transform: "translate(2.789 2.899)",
    fill: "#00abcb"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwiter);
export default __webpack_public_path__ + "static/media/twiter.6809e06b11d5b088624294b6a69fc3c3.svg";
export { ForwardRef as ReactComponent };